const requestsActionTypes = {
  SET_REQUESTS_LIST_FILTERS: 'SET_REQUESTS_LIST_FILTERS',
  SET_IS_FILTERS_OR_SEARCH_IN_REQUESTS: 'SET_IS_FILTERS_OR_SEARCH_IN_REQUESTS',
};
export default requestsActionTypes;
